// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DVouZ","right":"styles_right__3H6IB"};